import React from 'react'
import { isEmpty } from 'lodash'
import { CircleFillGlyph, Information16 } from '@carbon/icons-react'
import { TooltipIcon } from '../../../Tooltip'
import Footer from './components/Footer'
import Section from './components/Section'

import './index.scss'

export default function Sidebar({ config = {} }) {
  const { sections, sidebarTitle, image, footer, status } = config
  return (
    <div className='sidebar'>
      {isEmpty(config) && <div>NO_DATA</div>}
      <TooltipIcon
        tooltipText='Non-interactive tooltip'
        renderIcon={Information16}
      />
      {sidebarTitle && (
        <h4 className='sidebar-title'>
          {sidebarTitle}
          {status?.enable && (
            <TooltipIcon
              className='status'
              tooltipText={status?.text}
              align='start'
              direction='right'
            >
              <CircleFillGlyph className={`icon-${status?.color}`} />
            </TooltipIcon>
          )}
        </h4>
      )}
      {image && (
        <div className='image-wrapper'>
          <img height='auto' width='100%' src={image} alt='item' />
        </div>
      )}
      {sections &&
        sections.map((section) => (
          <Section key={`Section-${section.id}`} section={section} />
        ))}
      {!isEmpty(footer) && <Footer data={footer} />}
    </div>
  )
}
